export const STORAGE_KEY_THEME = 'tuning-proxy-landing-theme';

export function getStoredDarkMode() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY_THEME);
    return stored !== 'light';
  } catch (_) {
    return true;
  }
}

export function persistDarkMode(darkMode) {
  try {
    localStorage.setItem(STORAGE_KEY_THEME, darkMode ? 'dark' : 'light');
  } catch (_) {
    // ignore storage access failures
  }
}

export function getSiteTheme(darkMode) {
  if (darkMode) {
    return {
      bg: '#070A12',
      panel: '#0B1220',
      panel2: '#0F172A',
      border: 'rgba(148, 163, 184, 0.16)',
      border2: 'rgba(148, 163, 184, 0.22)',
      text: '#E5E7EB',
      muted: '#94A3B8',
      muted2: '#64748B',
      primary: '#60A5FA',
      primary2: '#3B82F6',
      danger: '#F87171',
      shadow: '0 20px 55px rgba(2, 6, 23, 0.65)',
      navBg: 'rgba(7, 10, 18, 0.66)',
      glowBg: `
        radial-gradient(1100px 380px at 50% 0%, rgba(59, 130, 246, 0.18), transparent 58%),
        radial-gradient(900px 320px at 0% 35%, rgba(96, 165, 250, 0.10), transparent 52%),
        radial-gradient(900px 320px at 100% 55%, rgba(56, 189, 248, 0.08), transparent 52%)
      `,
      btnGhostBg: 'rgba(15, 23, 42, 0.55)',
      kickerBg: 'rgba(15, 23, 42, 0.55)',
      cardBg: 'linear-gradient(180deg, #0B1220 0%, rgba(11, 18, 32, 0.55) 100%)',
      brandBadgeBg: 'rgba(15, 23, 42, 0.55)',
      previewTopBg: 'rgba(15, 23, 42, 0.55)',
      addressBarBg: 'rgba(7, 10, 18, 0.55)',
      innerPreviewBg: 'rgba(248, 250, 252, 0.06)',
      footerBg: 'rgba(7, 10, 18, 0.66)',
      codeBlockBg: 'rgba(15, 23, 42, 0.6)',
      inputBg: '#0F172A',
      oauthBtnBg: 'rgba(15, 23, 42, 0.55)',
      btnPrimaryColor: '#EFF6FF',
      alertBg: 'rgba(248, 113, 113, 0.08)',
      alertBorder: 'rgba(248, 113, 113, 0.35)',
      alertText: '#FECACA',
      fieldErrorColor: '#FECACA'
    };
  }

  return {
    bg: '#F8FAFC',
    panel: '#FFFFFF',
    panel2: '#F1F5F9',
    border: 'rgba(100, 116, 139, 0.25)',
    border2: 'rgba(100, 116, 139, 0.35)',
    text: '#0F172A',
    muted: '#475569',
    muted2: '#64748B',
    primary: '#3B82F6',
    primary2: '#2563EB',
    danger: '#DC2626',
    shadow: '0 20px 55px rgba(15, 23, 42, 0.12)',
    navBg: 'rgba(255, 255, 255, 0.85)',
    glowBg: `
      radial-gradient(1100px 380px at 50% 0%, rgba(59, 130, 246, 0.08), transparent 58%),
      radial-gradient(900px 320px at 0% 35%, rgba(96, 165, 250, 0.06), transparent 52%),
      radial-gradient(900px 320px at 100% 55%, rgba(56, 189, 248, 0.05), transparent 52%)
    `,
    btnGhostBg: 'rgba(241, 245, 249, 0.9)',
    kickerBg: 'rgba(241, 245, 249, 0.95)',
    cardBg: 'linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0.95) 100%)',
    brandBadgeBg: 'rgba(241, 245, 249, 0.95)',
    previewTopBg: 'rgba(241, 245, 249, 0.9)',
    addressBarBg: 'rgba(248, 250, 252, 0.95)',
    innerPreviewBg: 'rgba(15, 23, 42, 0.04)',
    footerBg: 'rgba(255, 255, 255, 0.85)',
    codeBlockBg: 'rgba(241, 245, 249, 0.95)',
    inputBg: '#F1F5F9',
    oauthBtnBg: 'rgba(241, 245, 249, 0.9)',
    btnPrimaryColor: '#FFFFFF',
    alertBg: 'rgba(220, 38, 38, 0.1)',
    alertBorder: 'rgba(220, 38, 38, 0.35)',
    alertText: '#B91C1C',
    fieldErrorColor: '#B91C1C'
  };
}

export function getSplitPanelTheme(theme) {
  return {
    cardBg: theme.cardBg,
    border: theme.border,
    shadow: theme.shadow
  };
}
